(() => {
  const bp = window.matchMedia('(min-width: 992px)');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const body = document.body;
  const menuToggle = $('.menu-toggle');
  const mobileNav = $('.mobile-nav');
  const mobileClose = $('.mobile-nav__close');
  const cartButtons = $$('[data-action="toggle-cart"]');
  const sideCart = $('.side-cart');
  const cartClose = $('.side-cart__close');
  const cartOverlay = $('.cart-overlay');

  const cartCountEls = $$('[data-cart-count]');
  const updateCartCount = n => cartCountEls.forEach(el => (el.textContent = n));

  const lockScroll = lock => {
    body.style.overflow = lock ? 'hidden' : '';
  };

  const toggleMobileNav = forceOpen => {
    if (!mobileNav || !menuToggle) return;
    const shouldOpen = forceOpen ?? !mobileNav.classList.contains('open');
    mobileNav.classList.toggle('open', shouldOpen);
    mobileNav.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    menuToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    body.classList.toggle('nav-open', shouldOpen);
    lockScroll(shouldOpen);
  };

  menuToggle?.addEventListener('click', () => toggleMobileNav());
  mobileClose?.addEventListener('click', () => toggleMobileNav(false));
  mobileNav?.addEventListener('click', e => {
    if (e.target === mobileNav) toggleMobileNav(false);
  });

  const setCartState = open => {
    if (!sideCart || !cartOverlay) return;
    sideCart.classList.toggle('open', open);
    cartOverlay.classList.toggle('visible', open);
    sideCart.setAttribute('aria-hidden', open ? 'false' : 'true');
    lockScroll(open);
  };

  cartButtons.forEach(btn =>
    btn.addEventListener('click', () => {
      const open = !sideCart.classList.contains('open');
      setCartState(open);
    })
  );
  cartClose?.addEventListener('click', () => setCartState(false));
  cartOverlay?.addEventListener('click', () => setCartState(false));

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (mobileNav?.classList.contains('open')) toggleMobileNav(false);
    if (sideCart?.classList.contains('open')) setCartState(false);
  });

  const dropdowns = $$('.nav .has-dropdown');
  const closeAllDropdowns = () =>
    dropdowns.forEach(d => d.classList.remove('open'));

  dropdowns.forEach(dd => {
    const trigger = $('a', dd);
    if (!trigger) return;

    trigger.addEventListener('click', e => {
      if (!bp.matches) {
        e.preventDefault();
        dropdowns.forEach(other => {
          if (other !== dd) other.classList.remove('open');
        });
        dd.classList.toggle('open');
      }
    });
  });

  document.addEventListener('click', e => {
    if (bp.matches) return;
    if (!e.target.closest('.nav .has-dropdown')) closeAllDropdowns();
  });

  bp.addEventListener?.('change', () => {
    closeAllDropdowns();
    if (mobileNav?.classList.contains('open')) toggleMobileNav(false);
    lockScroll(false);
  });

  const thumbSwiper = new Swiper('.thumb-swiper', {
    spaceBetween: 12,
    slidesPerView: 4,
    breakpoints: {
      0: {
        slidesPerView: 3,
      },
      600: {
        slidesPerView: 4,
      },
    },
  });

  const mainSwiper = new Swiper('.main-swiper', {
    spaceBetween: 16,
    effect: 'slide',
    loop: true,
    thumbs: {
      swiper: thumbSwiper,
    },
  });

  let reviewsSwiper = null;

  function initReviewsSwiper() {
    const breakpoint = window.matchMedia('(min-width: 1240px)');

    const enableSwiper = () => {
      if (!reviewsSwiper) {
        reviewsSwiper = new Swiper('.reviews-swiper', {
          speed: 500,
          loop: false,
          pagination: {
            el: '.reviews-swiper .swiper-pagination',
            clickable: true,
          },
          slidesPerView: 1.12,
          spaceBetween: 16,
          slidesOffsetAfter: 16,
          breakpoints: {
            576: {
              slidesPerView: 1.4,
              spaceBetween: 16,
              slidesOffsetAfter: 24,
            },
            768: { slidesPerView: 2.1, spaceBetween: 16 },
          },
        });
      }
    };

    const disableSwiper = () => {
      if (reviewsSwiper) {
        reviewsSwiper.destroy(true, true);
        reviewsSwiper = null;
      }
    };

    const checkBreakpoint = () => {
      if (breakpoint.matches) {
        disableSwiper(); // desktop → grid
      } else {
        enableSwiper(); // mobile/tablet → slider
      }
    };

    // inicijalno
    checkBreakpoint();

    // reaguj na resize
    breakpoint.addEventListener('change', checkBreakpoint);
  }

  document.addEventListener('DOMContentLoaded', initReviewsSwiper);

  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartCount(cart.item_count);
    } catch (e) {}
  });

  const variations = document.querySelectorAll('.single-variation');

  variations.forEach(item => {
    item.addEventListener('click', () => {
      variations.forEach(el => el.classList.remove('active'));
      item.classList.add('active');
    });
  });

  document.addEventListener('click', async e => {
    const btn = e.target.closest('.cart-button');
    if (!btn) return;
    e.preventDefault();

    try {
      const cart = await fetchCart();
      renderSideCart(cart);
      updateCartCount(cart.item_count);
      if (typeof setCartState === 'function') {
        setCartState(true);
      } else {
        const panel = document.querySelector('.side-cart');
        const overlay = document.querySelector('.cart-overlay');
        panel?.classList.add('open');
        overlay?.classList.add('visible');
        panel?.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    } catch (err) {
      console.error('Cart fetch failed', err);
    }
  });

  //   // ==== AJAX ADD TO CART + RENDER SIDE CART ====

  //   const cartBody = document.querySelector('.side-cart .side-cart__body');
  //   const subtotalEl = document.querySelector(
  //     '.side-cart .summary-row:not(.total) span:last-child'
  //   );
  //   const totalEl = document.querySelector(
  //     '.side-cart .summary-row.total span:last-child'
  //   );
  //   const checkoutBtn = document.querySelector('.side-cart .btn.btn-primary');
  //   if (checkoutBtn) checkoutBtn.setAttribute('href', '/checkout');

  //   const productForms = Array.from(
  //     document.querySelectorAll(
  //       'form[action="/cart/add"], form[action*="/cart/add"]'
  //     )
  //   );

  //   let submitMode = 'add';

  //   const CURRENCY =
  //     (window.Shopify && Shopify.currency && Shopify.currency.active) ||
  //     (window.Shopify && Shopify.shop && Shopify.shop.currency) ||
  //     'USD';

  //   const LOCALE = document.documentElement.lang || navigator.language || 'en-US';

  //   function formatMoneyFromCents(cents) {
  //     const value = (parseInt(cents, 10) || 0) / 100;
  //     try {
  //       return new Intl.NumberFormat(LOCALE, {
  //         style: 'currency',
  //         currency: CURRENCY,
  //       }).format(value);
  //     } catch (e) {
  //       return value.toFixed(2);
  //     }
  //   }

  //   function initialsFromTitle(t) {
  //     if (!t) return '—';
  //     const parts = t.trim().split(/\s+/).slice(0, 2);
  //     return parts
  //       .map(p => p[0])
  //       .join('')
  //       .toUpperCase();
  //   }

  //   function renderCartItem(it) {
  //     const thumb = it.image
  //       ? `<img src="${it.image}" alt="${it.product_title}">`
  //       : `<span>${initialsFromTitle(it.product_title)}</span>`;
  //     const variant =
  //       it.variant_title && it.variant_title !== 'Default Title'
  //         ? ` – ${it.variant_title}`
  //         : '';

  //     return `
  //   <div class="cart-item" data-key="${it.key}">
  //     <div class="cart-item__thumb">${thumb}</div>
  //     <div class="cart-item-main">
  //       <div class="cart-item-holder">
  //         <div class="cart-item__name">${it.product_title}${variant}</div>
  //         <button type="button" class="cart-remove" aria-label="remove">×</button>
  //       </div>
  //       <div class="cart-item__meta">
  //         <span>Qty ${it.quantity}</span>
  //         <span>${formatMoneyFromCents(it.final_line_price)}</span>
  //       </div>
  //     </div>
  //   </div>
  // `;
  //   }

  //   async function fetchCart() {
  //     const res = await fetch('/cart.js', {
  //       method: 'GET',
  //       headers: { Accept: 'application/json' },
  //       credentials: 'same-origin',
  //       cache: 'no-store',
  //     });
  //     if (!res.ok) throw new Error('Cart fetch failed');
  //     return res.json();
  //   }

  //   async function addToCartAjax(payload) {
  //     const res = await fetch('/cart/add.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Accept: 'application/json',
  //       },
  //       body: JSON.stringify(payload),
  //     });
  //     if (!res.ok) {
  //       let err;
  //       try {
  //         err = await res.json();
  //       } catch (e) {}
  //       throw new Error(err?.description || 'Add to cart failed');
  //     }
  //     return res.json();
  //   }

  //   async function removeFromCart(key) {
  //     const res = await fetch('/cart/change.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Accept: 'application/json',
  //       },
  //       body: JSON.stringify({ id: key, quantity: 0 }),
  //     });
  //     if (!res.ok) throw new Error('Remove failed');
  //     return res.json();
  //   }

  //   function renderSideCart(cart) {
  //     if (cartBody) {
  //       if (!cart.items.length) {
  //         cartBody.innerHTML = `<div class="cart-empty"><h4>Your cart is empty.</h4></div>`;
  //       } else {
  //         cartBody.innerHTML = cart.items.map(renderCartItem).join('');
  //       }
  //     }
  //     if (subtotalEl)
  //       subtotalEl.textContent = formatMoneyFromCents(cart.items_subtotal_price);
  //     if (totalEl) totalEl.textContent = formatMoneyFromCents(cart.total_price);
  //   }

  //   if (cartBody) {
  //     cartBody.addEventListener('click', async e => {
  //       const removeBtn = e.target.closest('.cart-remove');
  //       if (!removeBtn) return;

  //       const itemEl = removeBtn.closest('.cart-item');
  //       const key = itemEl?.dataset.key;
  //       if (!key) return;

  //       try {
  //         await removeFromCart(key);
  //         const cart = await fetchCart();
  //         renderSideCart(cart);
  //         updateCartCount(cart.item_count);
  //       } catch (err) {
  //         console.error(err);
  //         alert('Nije uspelo uklanjanje proizvoda.');
  //       }
  //     });
  //   }

  //   productForms.forEach(form => {
  //     const addBtn = form.querySelector(
  //       '[data-el="add-to-cart-btn"], button[name="add"]:not([data-el="buy-now-btn"])'
  //     );
  //     const buyBtn = form.querySelector('[data-el="buy-now-btn"]');

  //     addBtn?.addEventListener('click', () => {
  //       submitMode = 'add';
  //     });
  //     buyBtn?.addEventListener('click', () => {
  //       submitMode = 'buy';
  //     });

  //     form.addEventListener('submit', async e => {
  //       e.preventDefault();

  //       const fd = new FormData(form);
  //       const id = fd.get('id');
  //       const qty = parseInt(fd.get('quantity') || '1', 10);

  //       const props = {};
  //       for (const [k, v] of fd.entries()) {
  //         const m = k.match(/^properties\[(.+)\]$/);
  //         if (m) props[m[1]] = v;
  //       }

  //       const payload = { id, quantity: isNaN(qty) ? 1 : qty };
  //       if (Object.keys(props).length) payload.properties = props;

  //       try {
  //         await addToCartAjax(payload);

  //         if (submitMode === 'buy') {
  //           window.location.href = '/checkout';
  //           return;
  //         }

  //         const cart = await fetchCart();
  //         renderSideCart(cart);
  //         updateCartCount(cart.item_count);
  //         if (typeof setCartState === 'function') setCartState(true);
  //         else
  //           document
  //             .querySelector('.side-cart')
  //             ?.setAttribute('aria-hidden', 'false');
  //       } catch (err) {
  //         console.error(err);
  //         alert(err.message || 'Could not add to cart.');
  //       }
  //     });
  //   });

  // ==== /AJAX ADD TO CART ====

  const buyButtons = document.querySelector('.buy-buttons');
  const target = document.querySelector('.why-armadillo');
  if (!buyButtons || !target) return;

  function handleScroll() {
    const rect = target.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top <= windowHeight) {
      buyButtons.style.opacity = '0';
      buyButtons.style.pointerEvents = 'none';
    } else {
      buyButtons.style.opacity = '1';
      buyButtons.style.pointerEvents = 'auto';
    }
  }

  window.addEventListener('scroll', handleScroll);
  handleScroll();
})();

(() => {
  const mqDesktop = window.matchMedia('(min-width:1240px)');

  const ready = fn => {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  };

  ready(() => {
    const tabsContainer = document.querySelector('.faq-tabs');
    const panelsContainer = document.querySelector('.faq-panels');
    if (!tabsContainer || !panelsContainer) return;

    const tabs = Array.from(document.querySelectorAll('.faq-tab'));
    const panels = Array.from(document.querySelectorAll('.faq-panel'));
    if (!tabs.length || !panels.length) return;

    let lastDesktopId = (
      tabs.find(t => t.classList.contains('active')) || tabs[0]
    ).dataset.panel;

    function activateDesktop(targetId) {
      lastDesktopId = targetId;
      tabs.forEach(btn => {
        const isActive = btn.dataset.panel === targetId;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(p => {
        const show = p.id === targetId;
        p.hidden = !show;
        p.classList.toggle('active', show);
      });
    }

    function openMobileExclusive(targetId, allowCollapse = true) {
      const panel = document.getElementById(targetId);
      const btn = tabs.find(b => b.dataset.panel === targetId);
      if (!panel || !btn) return;

      const isCurrentlyOpen = !panel.hidden;

      if (isCurrentlyOpen && allowCollapse) {
        panels.forEach(p => {
          p.hidden = true;
          p.classList.remove('active');
        });
        tabs.forEach(b => {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        return;
      }

      panels.forEach(p => {
        p.hidden = true;
        p.classList.remove('active');
      });
      tabs.forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });

      panel.hidden = false;
      panel.classList.add('active');
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
    }

    function toAccordion() {
      tabs.forEach(btn => {
        const panel = document.getElementById(btn.dataset.panel);
        if (panel && panel.parentElement !== tabsContainer) {
          btn.after(panel);
        }
      });

      panels.forEach(p => {
        p.hidden = true;
        p.classList.remove('active');
      });
      tabs.forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });

      if (lastDesktopId) openMobileExclusive(lastDesktopId, false); // ne kolabira odmah
    }

    function toTabsLayout() {
      panels.forEach(p => {
        if (p.parentElement !== panelsContainer) panelsContainer.appendChild(p);
      });

      const candidate = lastDesktopId || (tabs[0] && tabs[0].dataset.panel);
      activateDesktop(candidate);
    }

    tabs.forEach(btn => {
      btn.addEventListener('click', () => {
        if (mqDesktop.matches) {
          activateDesktop(btn.dataset.panel);
        } else {
          openMobileExclusive(btn.dataset.panel, true); // klik na aktivni ga zatvara
        }
      });
    });

    function applyLayout() {
      if (mqDesktop.matches) toTabsLayout();
      else toAccordion();
    }

    if (mqDesktop.addEventListener)
      mqDesktop.addEventListener('change', applyLayout);
    else mqDesktop.addListener(applyLayout);

    applyLayout();
  });
})();
